import oemConfigs from '@/plugins/oem'

const COOKIE_OEM_UNIQUE = '_YAGISH_OEM_UNIQUE_ID'

const SITE_PARENT = process.env.VUE_APP_SITE_OEM

const OemContext = {
  install: function (Vue) {
    const OemContext = new Vue({
      data: function () {
        return {
          currentOemUniqueId: null,
          oemConfigs
        }
      },

      computed: {
        currentOemId () {
          return SITE_PARENT || null
        },

        // isOemUniqueMode () {
        //   return !!this.currentOemUniqueId
        // },

        currentOemConfig () {
          if (!this.currentOemId) return null
          return this.oemConfigs[this.currentOemId] || null
        },

        currentOemUniqueConfig () {
          if (!this.currentOemId || !this.currentOemUniqueId) return null

          const parent = this.oemConfigs[this.currentOemId]
          if (!parent || !parent.ids) return null

          return parent.ids[this.currentOemUniqueId] || null
        }
      },

      methods: {
        /* =====================================
         * 1. バリデーション
         * ===================================== */

        // isValidParent (parentId) {
        //   return !!this.oemConfigs[parentId]
        // },

        isValidChild (parentId, uniqueId) {
          const parent = this.oemConfigs[parentId]
          if (!parent || !parent.ids) return false
          return !!parent.ids[uniqueId]
        },

        isFormatAccessible (formatId) {
          if (this.currentOemConfig) {
            const allowed = this.getAllowedFormats()
            if (!allowed) return false
            return allowed.includes(formatId)
          }

          const allOemConfigs = this.oemConfigs
          const isOemOnly = Object.values(allOemConfigs).some(cfg =>
            cfg.oemOnlyFormats && cfg.oemOnlyFormats.includes(formatId)
          )

          return !isOemOnly
        },

        /* =====================================
         * 2. 状態同期・制御（route / cookie）
         * ===================================== */

        syncFromRoute (route) {
          const parent = SITE_PARENT
          const unique = route.params.oemUniqueId

          if (!parent || !this.oemConfigs[parent]) return

          const validIds = this.oemConfigs[parent].ids

          if (unique && validIds && validIds[unique]) {
            if (this.currentOemUniqueId !== unique) {
              this.setOem(unique)
            }
            return
          }

          if (!unique && Vue.prototype.$cookies) {
            const cookieUnique = Vue.prototype.$cookies.get(COOKIE_OEM_UNIQUE)
            if (cookieUnique && validIds && validIds[cookieUnique]) {
              this.currentOemUniqueId = cookieUnique
            }
          }
        },

        setOem (oemUniqueId = null) {
          this.currentOemUniqueId = oemUniqueId || null

          if (!Vue.prototype.$cookies) return

          if (oemUniqueId) {
            Vue.prototype.$cookies.set(COOKIE_OEM_UNIQUE, oemUniqueId)
          } else {
            this.clearOem()
          }
        },

        clearOem () {
          this.currentOemUniqueId = null

          if (!Vue.prototype.$cookies) return

          Vue.prototype.$cookies.remove(COOKIE_OEM_UNIQUE)
        },

        /* =====================================
         * 3. テンプレート制御
         * ===================================== */

        getAllowedFormats () {
          if (!this.currentOemConfig) return null
          return this.currentOemConfig.allowedFormats || null
        },

        getOemDefaultFormat: function () {
          if (!this.currentOemConfig) return null
          return this.currentOemConfig.defaultFormatId || null
        },

        isFormatAllowed (formatId) {
          const allowed = this.getAllowedFormats()
          return !allowed || allowed.includes(formatId)
        },

        filterAllowedFormats (formats) {
          const allowed = this.getAllowedFormats()
          if (!allowed) return formats

          return formats.filter(item => {
            const formatId = item.format_id || item.id || item
            return allowed.includes(formatId)
          })
        },

        // isOemOnlyFormat (formatId) {
        //   return this.currentOemConfig?.oemOnlyFormats?.includes(formatId) || false
        // },

        filterAccessibleFormats (formats) {
          return formats.filter(item => {
            const formatId = item.format_id || item.id || item
            return this.isFormatAccessible(formatId)
          })
        },

        isOemSite () {
          return !!this.currentOemId
        },

        /* =====================================
         * 4. 取得（表示データ）
         * ===================================== */

        getName () {
          const config = this.currentOemUniqueConfig
          return config && config.name ? config.name : ''
        },

        getText (key, defaultText) {
          const config = this.currentOemUniqueConfig
          if (!config || !config.texts) return defaultText
          return config.texts[key] || defaultText
        },

        getSupportBanners () {
          const config = this.currentOemUniqueConfig
          if (!config) return []
          return config.supportBanners || []
        },

        getNews () {
          const config = this.currentOemConfig
          if (!config) return []
          return config.newsItems || []
        },

        getShop () {
          const config = this.currentOemConfig
          if (!config) return []
          return config.shopItems || []
        },

        /* =====================================
         * 5. RT関連の制御
         * ===================================== */

        /**
         * RT機能が有効かどうかを判定
         * OEM環境では enableRT 設定に従う（デフォルト: false）
         * 通常サイトでは常に true
         */
        isOemEnabled () {
          // OEM環境でない場合は常にRT有効
          if (!this.currentOemId) return true

          const config = this.currentOemConfig
          if (!config) return true

          // enableRT が明示的に true の場合のみ有効、それ以外は無効
          return config.enableRT === true
        }
      }
    })

    Vue.prototype.$oemContext = OemContext
  }
}
export default OemContext
